<mat-sidenav-container class="container">
  <mat-sidenav
    class="sidenav"
    mode="side"
    opened
    fixedInViewport="true"
    fixedTopGap="64"
  >
    <mat-nav-list class="nav-list">
      <a mat-list-item routerLink="/">
        <i class="material-icons"> home </i>
        Início
      </a>
      <a mat-list-item routerLink="/products">
        <i class="material-icons"> storefront</i>
        Produtos
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
